import React from 'react';
import { FormControl, Button } from 'react-bootstrap';

const ViewHeader = (props) => {
    if (props.withSearch) {
        return (
            <React.Fragment>
                <h2 className={props.titleClass ? props.titleClass : ""}>{props.title}</h2>
                <div className="flex-search">
                    <div className="flex-row">
                        <FormControl autoComplete="off" name="search" placeholder="Search" className="list-search" onChange={props.onSearchChange} />
                        {props.sideSearch}
                        {props.renderFilterDate}
                    </div>
                    {props.rightButtons && props.rightButtons.map((button, i) => {
                        return <Button key={button.label + i} variant={button.variant} className="flex-align pull-right header-button" onClick={button.onClick}>{button.icon && (<button.icon style={{ marginTop: -4, marginRight: 6 }} />)}{button.label}</Button>
                    })}
                </div>
                <hr />

            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                <div className="flex-search">
                    <h2 className={props.titleClass ? props.titleClass : ""}>{props.title}</h2>
                    <div>
                        {props.rightButtons && props.rightButtons.map((button, i) => {
                            return <Button key={button.label + i} disabled={button.disabled} variant={button.variant} className="flex-align pull-right header-button" onClick={button.onClick}>{button.icon && (<button.icon style={{ marginTop: -4, marginRight: 6 }} />)}{button.label}</Button>
                        })}
                    </div>
                </div>
                <hr />
            </React.Fragment>
        );
    }

};

export default ViewHeader;